import loadable from "@loadable/component";

export const AdminHome = loadable(() => import("./AdminHome/home"));
export const AllScores = loadable(() => import("./AllScores/index"));
export const UserManagement = loadable(() => import("./UserManagement/index"));
